module.exports = __webpack_public_path__ + "static/media/kaneff.d454d8c3.png";